export default __webpack_public_path__ + "static/media/Pin_Job_Tow.380f17f4.svg";